import React from 'react';
// import PropTypes from 'prop-types';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import ChannelTransaction from './ChannelTransaction';
import ChannelDashboard from './ChannelDashboard';
import ChannelProfile from './ChannelProfile';

function ChannelRoutes() {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/dashboard`} component={ChannelDashboard} />
      <Route
        path={`${match.path}/transactions`}
        component={ChannelTransaction}
      />
      <Route path={`${match.path}/profile`} component={ChannelProfile} />
      <Redirect to={`${match.url}/dashboard`} />
    </Switch>
  );
}

ChannelRoutes.propTypes = {};

export default ChannelRoutes;
